<template lang="pug">
    v-card.pa-5
        crud-data-table(:service="customService" :headers="headers" noActions noAutoWidth)
        // @show="$router.push('/families/'+$event)" 
        // @delete="deleteItem($event)"
        //- create-button(:action="()=>{this.$router.push('/families/create')}")
</template>

<script>
import {CrudDataTable} from '@/components/reusable_components'
import {
    getFetchDataFunction,
} from '@/services/api/DataTableService'
// import ExampleDTService from '@/services/api/ExampleDTService'
// import PurchaseOrdersDTService from '@/services/api/purchaseorders/PurchaseOrdersDTService'
// import CrudCreateButton from '@/components/CrudCreateButton/CrudCreateButton'
import { mapActions, mapState } from 'vuex'

import { DELETE_ITEM } from '@/components/reusable_components/SnackbarModal/SnackbarActions'
// import FamilyServices from '@/services/api/family/FamilyServices'

export default {
    name: 'purchase-orders-list',
    props: {},
    data: function() {
        return {
            // service: PurchaseOrdersDTService,
            headers: [
                {
                    text: 'ID',
                    align: 'left',
                    sortable: 'false',
                    value: 'id',
                    editable: false,
                    width: '50px',
                },
                {
                    text: 'Proveedor',
                    align: 'left',
                    sortable: 'false',
                    value: 'provider_business_name',
                    editable: false,
                    width: 'auto',
                },
                {
                    text: 'Cantidad',
                    align: 'left',
                    sortable: 'false',
                    value: 'quantity',
                    editable: false,
                    width: null,
                },
                {
                    text: 'Fecha creación',
                    align: 'left',
                    sortable: 'true',
                    value: 'creation_date',
                    editable: false,
                    width: null,
                },
                {
                    text: 'Estado',
                    align: 'left',
                    sortable: 'false',
                    value: 'state',
                    editable: false,
                    width: null,
                },
                {
                    text: 'Fecha recepción',
                    align: 'left',
                    sortable: 'true',
                    value: 'receptionDate',
                    editable: false,
                    width: null,
                },

            ],
            selected: [],
            itemDeleteId : null,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        customService () {
            let id = this.$route.params.id
            let route = process.env.VUE_APP_API_ROUTE + `/pch_purchase_orders/wh_product/${id}`
            let dtFetchData = getFetchDataFunction(route)
            console.log('{ dtFetchData }', { dtFetchData })
            return { dtFetchData }
        }
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        deleteItem( event ) {

            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack( DELETE_ITEM )

            //
            let payload = this.fillSnack('warning','¿Deseas Eliminar item?', '')
            this.initSnackbar(payload)

            //
            this.itemDeleteId = event
        },
    },
    watch: {
        async responseConfirm( val ) {

            //
            if ( val === DELETE_ITEM ) {

                //
                this.resetSnackbarState()

                //
                let response = await FamilyServices.deleteFamily( this.itemDeleteId )

                //
                if ( response.status == 200 ) {

                    //                    
                    let payload = this.fillSnack( 'success', 'Familia Eliminada.', '' )
                    this.initSnackbar( payload )

                    //
                    this.$router.go()
                } else {

                    //
                    let payload = this.fillSnack( 'error', 'Error', response.error )
                    this.initSnackbar( payload )
                }
            }
        },
    },
    components: { 
        'crud-data-table': CrudDataTable,
        // 'create-button' : CrudCreateButton
     },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function(){
    
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>